import service from '@api/config'

// 临时授权访问信息
export const stsOss = (data) => {
  return service.request({
    url: `/oss/sts`,
    method: 'post',
    data: data
  })
}
// 解密
export const ossBrowse = (data) => {
  return service.request({
    url: `/oss/browse`,
    method: 'post',
    data: data
  })
}
